import React from 'react';
import axios from 'axios';
import { Nav } from '@douyinfe/semi-ui';
import { IconExit, IconKey } from '@douyinfe/semi-icons';

class LoginMenu extends React.Component {
    constructor(props) {
        super(props);

        this.state = {
            decodedToken: this.decodeToken(this.props.keycloak.token),
        };
    }

    decodeToken = (token) => {
        if (token) {
            const decodedToken = JSON.parse(atob(token.split('.')[1]));
            axios.defaults.headers.common['Authorization'] = `Bearer ${token}`;
            return decodedToken;
        }
        return {};
    }

    keycloakLogin = () => {
        this.props.keycloak.login().then(authenticated => {
            this.props.onLoginChange(authenticated);
        });
    }

    keycloakLogout = () => {
        this.props.keycloak.logout({redirectUri: `${window.location.protocol}//${process.env.REACT_APP_CYBERROSE_DEV_HOST}/`});
    }

    render() {
        return (
            <Nav.Item 
                itemKey={'login'}
                text={`${this.props.behaviour}`}
                icon={ this.props.behaviour === "LogIn / Register" ? <IconKey /> : <IconExit /> }
                onClick={ this.props.behaviour === "LogIn / Register" ? this.keycloakLogin : this.keycloakLogout }
            />
        );
    }

}

export default LoginMenu;